export default "__VITE_ASSET__Dv09cm_N__"